import { Injectable } from '@angular/core';
import {DaoGeneric} from "@Services/base/daoService";
import {InformationComplementaire} from "./information-complementaire.model";
import {environment} from "@Env/environment";
import {HttpClient} from "@angular/common/http";


@Injectable({
  providedIn: 'root'
})
export class InformationComplementaireService extends DaoGeneric<InformationComplementaire> {
  private url = `${environment.baseUrl}/api_archive/information_complementaire/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

}
